// extracted by mini-css-extract-plugin
export default {"overlay":"lx-z","bodyOpen":"mx-z","content":"nx-z","header":"ox-z","close":"px-z","closeNoHeading":"qx-z"};